import { addItemToCollection } from "directus/src/operations";

export async function createSurvey({ item }) {
  try {
    const data = await addItemToCollection("surveys", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
